export default __webpack_public_path__ + "static/media/Test5.ed51bf00.PNG";